export const getSourceList = (image) =>
  (Array.isArray(image) ? image : [image]).filter(Boolean);
export const getInitialState = ({ image, imageCache }) => {
  const sourceList = getSourceList(image);
  for (const { source, index } of sourceList) {
    if (!imageCache[source] && imageCache[source] !== false) {
      break;
    }
    if (imageCache[source] === true) {
      return {
        initialState: { currentIndex: index, isLoaded: true, isLoading: false },
        sourceList,
      };
    }
  }

  if (sourceList.length) {
    return {
      initialState: { currentIndex: 0, isLoaded: false, isLoading: true },
      sourceList,
    };
  }

  return {
    initialState: { isLoaded: false, isLoading: false },
    sourceList,
  };
};
export const getChangedSources = ({ image, previousSources }) => {
  const src = getSourceList(image);
  const srcAdded = src.filter((s) => previousSources.indexOf(s) === -1);
  const srcRemoved = previousSources.filter((s) => src.indexOf(s) === -1);
  if (srcAdded.length || srcRemoved.length) {
    return src;
  }
  return false;
};
